/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';
import ClearButton from '../buttons/ClearButton';
import Icon from './Icon';

type Props = {
  autoFocus?: boolean,
  className?: string,
  onCancel?: () => void,
  onClear: () => void,
  onSearch: () => void,
  placeholder?: string,
  value?: string
};

const Wrapper = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: theme.color.panel,
  color: theme.color.panelAccent,
  fontSize: '0.875rem',
  justifyContent: 'space-between',
  flexBasis: '100%',
  padding: '0.5rem 0.8rem'
}));

const PlayerSearchInput = styled('input')(({ theme }) => ({
  border: 0,
  background: 'none',
  outline: 'none',
  width: '100%',
  '&::placeholder': {
    color: theme.color.panelAccent
  }
}));

const CancelButton = styled.button(({ theme }) => ({
  outline: 'none',
  paddingRight: theme.spacing.small
}));

class SearchBar extends React.PureComponent<Props> {
  props: Props;

  inputRef = React.createRef(); // eslint-disable-line react/sort-comp

  static defaultProps = {
    autoFocus: false,
    value: '',
    onCancel: undefined,
    className: undefined,
    placeholder: 'Search'
  };

  componentDidMount() {
    const { autoFocus } = this.props;

    if (autoFocus && this.inputRef.current) {
      this.inputRef.current.focus();
    }
  }

  componentWillUnmount() {
    const { onClear } = this.props;

    onClear();
  }

  handleChange = (event: SyntheticEvent<*>) => {
    const { onSearch } = this.props;

    onSearch(event.target.value);
  };

  handleClear = () => {
    const { onClear } = this.props;

    onClear();
    this.inputRef.current.focus();
  };

  render() {
    const { className, onCancel, placeholder, value } = this.props;

    return (
      <Wrapper className={className}>
        <PlayerSearchInput
          type="search"
          ref={this.inputRef}
          onChange={this.handleChange}
          placeholder={placeholder}
          value={value}
        />
        {value ? <ClearButton onClick={this.handleClear} /> : <Icon type="icon-search" />}
        {onCancel && value && <CancelButton onClick={onCancel}>cancel</CancelButton>}
      </Wrapper>
    );
  }
}

export default SearchBar;
